import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, WHATSAPP } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const WhatsappTemplateList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.string, width: 90, show: false },
			{ Header: 'templateName', accessor: 'templateName', filterType: FilterType.string },
			{ Header: 'parameterCount', accessor: 'parameterCount', filterType: FilterType.number, show: false },
			{ Header: 'language', accessor: 'templateLanguage', filterType: FilterType.multiSelection },
			{
				Header: 'whatsappRecordID',
				accessor: 'whatsappTemplateId',
				filterType: FilterType.string,
				width: 200,
				show: false
			},
			{ Header: 'category', accessor: 'category', filterType: FilterType.string },
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'isCreatedAtOTO',
				accessor: 'isCreatedAtOTO',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 100
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.WHATSAPP_TEMPLATES}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={WHATSAPP.GET_WHATSAPP_TEMPLATE_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="whatsappTemplates"
			/>
		</TabTableContainer>
	);
};

export default WhatsappTemplateList;
